import _ from "lodash"
import { MessagesDICT } from "../types"
import { AppLocale } from "../../../../../backend/src/config/locales"

export const loadLocaleData = (locale: AppLocale) => {
    switch (locale) {
        case "cs":
        default:
            return import("../../../locales/cs.json")
    }
}

export const createMessages = (obj: object, prefix?: string): MessagesDICT => {
    const m: MessagesDICT = {}

    Object.keys(obj).map((key) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const value = (obj as any)[key]
        if (value === undefined || value === null) m[`${prefix ? prefix + "." : ""}${key}`] = null
        else {
            if (_.isString(value)) m[`${prefix ? prefix + "." : ""}${key}`] = value
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (_.isObject(value)) {
                const section = createMessages(value, key)
                Object.keys(section).map((key) => (m[`${prefix ? prefix + "." : ""}${key}`] = section[key]))
            }
        }
    })

    return m
}

export const getMessages = (msgs: MessagesDICT): Record<string, string> => {
    const dict: Record<string, string> & { [index: string]: string } = {}
    Object.keys(msgs).map((key) => (dict[key] = msgs[key] ?? key))
    return dict
}
